import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";

const IconSpecialPromotions = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.88 17.742l.12.008h20l.12-.008c.84-.11.84-1.375 0-1.484L22 16.25A2.25 2.25 0 0119.75 14V9a7.75 7.75 0 00-15.5 0v5a2.25 2.25 0 01-2.096 2.245L2 16.25c-.958 0-.998 1.378-.12 1.492zM12 2.75A6.25 6.25 0 0118.25 9v5l.005.2a3.73 3.73 0 00.675 1.954l.071.096H4.998l.072-.096c.428-.61.68-1.352.68-2.154V9A6.25 6.25 0 0112 2.75zm1.081 17.874a.75.75 0 111.298.752 2.75 2.75 0 01-4.758 0 .75.75 0 011.24-.837l.058.085a1.25 1.25 0 002.081.123l.081-.123z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(IconSpecialPromotions, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;